import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const CrmPage = lazy(() => import('@cobliteam/crm/src/pages/CrmPage'));

const routes = [
  {
    path: Location.CRM_DEVOLUTION,
    component: CrmPage,
    exact: true,
  },
  {
    path: Location.CRM_SCHEDULE,
    component: CrmPage,
    exact: true,
  },
  {
    path: Location.CRM_SHIPMENT,
    component: CrmPage,
    exact: true,
  },
];

export default routes;
